import { motion } from "framer-motion";
import SectionHeader from "@/components/SectionHeader";
import { PROCESS_STEPS } from "@/data/site";

export default function ProcessTimeline() {
  return (
    <section className="relative bg-white py-24 sm:py-32" data-testid="process-section">
      <div className="container-x">
        <SectionHeader
          overline="How we work"
          title={<>A 9-step process,<br />tuned for <span className="text-emerald-brand">accountability</span>.</>}
          subtitle="Our integrated workflow takes projects from first conversation to final commissioning — with explicit milestones, deliverables and review gates."
        />

        <div className="mt-16 relative">
          {/* Vertical line */}
          <div className="absolute left-6 top-0 bottom-0 w-px bg-gradient-to-b from-emerald-brand via-gold to-navy/20 hidden md:block" />

          <div className="space-y-10">
            {PROCESS_STEPS.map((s, i) => (
              <motion.div
                key={s.n}
                initial={{ opacity: 0, x: -16 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.5, delay: i * 0.05 }}
                className="relative grid md:grid-cols-12 gap-6 md:gap-10 items-start"
                data-testid={`process-step-${s.n}`}
              >
                <div className="md:col-span-2 flex md:block items-center gap-4">
                  <div className="relative">
                    <div className="w-12 h-12 grid place-items-center bg-white border-2 border-navy md:ml-0 z-10 relative">
                      <span className="font-display font-bold text-navy text-sm">{s.n}</span>
                    </div>
                  </div>
                </div>
                <div className="md:col-span-4">
                  <h3 className="font-display font-bold text-2xl text-navy">{s.title}</h3>
                </div>
                <div className="md:col-span-6">
                  <p className="text-base text-slate-brand leading-relaxed">{s.body}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
